import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import jwt_decode from 'jwt-decode';
import { User } from '../models/user.interface';

export interface SessionData {
  accessToken: string;
  refreshToken: string;
}

@Injectable({
  providedIn: 'root',
})
export class SessionDataService {
  private userRoles: string[] | undefined;

  constructor(private storageService: StorageService) {
    this.resolveUserRoles();
  }

  setSessionData(sessionData: SessionData): boolean {
    const tokenInfo = this.decodeAccessToken(sessionData.accessToken);
    if (!tokenInfo || tokenInfo.exp <= 0) {
      return false;
    }

    const user: User = {
      name: tokenInfo.name,
      email: tokenInfo.email,
      rol: tokenInfo.groups
    };

    this.storageService.setItem('access-token', sessionData.accessToken);
    this.storageService.setItem(
      'refresh-token',
      sessionData.refreshToken
    );
    this.storageService.setItem('user', JSON.stringify(user));
    this.userRoles = tokenInfo.scope;

    return true;
  }

  getUserRoles() {
    return this.userRoles;
  }

  private resolveUserRoles() {
    if (this.userRoles) {
      return;
    }

    const accessToken = this.storageService.getItem('access-token');
    if (accessToken) {
      const tokenData = this.decodeAccessToken(accessToken);
      this.userRoles = tokenData?.scope;
    }
  }

  private decodeAccessToken(
    token: string
  ): { name: string; email: string; scope: string[]; groups: string[]; exp: number } | null {
    try {
      return jwt_decode(token);
    } catch (error) {
      return null;
    }
  }
}
